module.exports = MainVis = function(el){
  this.element = $(el);
  this.state = $('.js-hamburger-state');
  this.win = $(window);
  this.device;
  this.checkDevice()
  this.resize();
  this.event();
};
MainVis.prototype.event = function(){
  var fixed = (this.device === 'pc') ? $('.fixed') : $('.fixed-news'),
      _h = this.win.height() - $('.header').outerHeight() - fixed.outerHeight();
  this.element.height(_h);
};
MainVis.prototype.resize = function(){
  var self = this;
  this.win.on('resize', function(){
    var timer = false;
    if(timer !== false){
      clearTimeout(timer);
    }
    timer = setTimeout(function(){
      self.checkDevice();
      self.event();
    },100);
  });
};
MainVis.prototype.checkDevice = function(){
  var isSP = this.state.is(':visible');
  if(isSP){
    this.device = 'sp';
  }else{
    this.device = 'pc';
  }
}


//////////////////
// WEBPACK FOOTER
// ./js/_modules/mainVis.js
// module id = 7
// module chunks = 0